const { styled } = require("@material-ui/core");

export const MobileVisible = styled('div')(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: "none"
    }
}))

export const DesktopVisible = styled('div')(({ theme }) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
        display: "block"
    }
}))